import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './../http.service';

@Injectable({
  providedIn: 'root'
})
export class NationsService {
  constructor(private httpService: HttpService) {}

  getNations(): Observable<{ nations: string[] }> {
    return this.httpService.httpGet('nations');
  }
}
